/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * Styles for the new campaign rateplan card body
 *
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.39.0
 */

import { Typography } from '@nexign/scc-ui-kit';
import styled from 'styled-components';

import { IProductsCardsItemStyled } from '@pages/PageProducts/components/styled/ProductsContentStyled';
import { colors } from '@theme/index';

type TVolumeTextStyled = {
	$lineHeight?: string;
};

type TVolumesStyled = {
	$alignItems?: string;
};

type TDescriptionTextStyled = {
	$isDashedUnderline?: boolean;
};

type TVerticalDivStyled = {
	$alignItems?: string;
	$height?: string;
    $marginTop?: string;
    $marginBottom?: string;
};

type TCampaignRateplanItem = {
    isSelected: boolean;
}

export const CampaignRateplan2025ItemStyled = styled.div.attrs(({ isSelected }: TCampaignRateplanItem) => ({
    className: `campaign-rateplan-item ${isSelected ? 'selected' : ''}`,
}))<IProductsCardsItemStyled>`
    width: fit-content;
    height: fit-content;

    margin: 0 16px 16px 0;
    background: ${colors.tariffsAndServicesCardBgColor};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
    border-radius: 24px;
    border: 1px solid ${colors.tariffsAndServicesCardBorderColorNormal};

    display: flex;

    cursor: pointer;

    &:hover {
        border: 1px solid ${colors.tariffsAndServicesCardBorderColorHover};
    }

    &.selected {
        outline: 2px solid ${colors.tariffsAndServicesCardBorderColorSelected};
        box-shadow: 0 2px 8px rgba(0, 185, 86, 0.16);
    }
`;

export const RatePlanCard2025Styled = styled.div`
    width: fit-content;
	height: 494px;
	border-radius: 24px;
	opacity: 1;
`;

export const RatePlanCard2025BodyStyled = styled.div`
	width: 265px;
	height: 390px;
	border-radius: 24px;
	justify-content: space-between;
	opacity: 1;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
	background-color: ${colors.backgroundColorWhite};
	bottom: 36px;
	position: relative;
`;

export const VerticalDivStyled = styled.div<TVerticalDivStyled>`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: ${props => props.$alignItems ?? ''};
	width: 100%;
	height: ${props => props.$height ?? 'fit-content'};
	gap: 8px;
    margin-top: ${props => props.$marginTop ?? ''};
    margin-bottom: ${props => props.$marginBottom ?? ''};
`;

export const VolumesStyled = styled.div<TVolumesStyled>`
	display: flex;
	flex-direction: row;
	align-items: ${props => props.$alignItems ?? 'flex-start'};
	width: 100%;
	height: 36px;
	gap: 4px;
`;

export const DescriptionSections = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	border-radius: 24px;
	gap: 16px;
	opacity: 1;
	padding: 16px;
`;

export const VolumeTextStyled = styled(Typography)<TVolumeTextStyled>`
	&.MuiTypography-root {
		margin: 0;
		font-size: 28px;
		line-height: ${props => props.$lineHeight ?? 'normal'};
	}
`;

export const DescriptionTextStyled = styled(Typography)<TDescriptionTextStyled>`
	&.MuiTypography-root {
		font-weight: 500;
		font-size: 12px;
		line-height: 14px;
		letter-spacing: 0;
		border-bottom: ${props => (props.$isDashedUnderline ? '1px dashed' : '')};
	}
`;
